import { addRatEventWithData } from '../../../utils/rat';
import * as tokenStorage from '@com.rakuten.esd/myr-web-storage';

export function createRatEventForClick(site: string, url: string) {
    const action = 'CLICK_RECOMMENDED_SERVICE';
    const data = {
        eventType: 'pv',
        pData: {
            path: window.location.pathname,
        },
        cpData: {
            actionType: action,
            client_id: tokenStorage.getActiveClientId(),
            site_id: site,
            to: url,
            event_name: action.replace(/_/g, ' ').toLowerCase(),
        },
    };
    addRatEventWithData(data);
}
